// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"form_form_wrapper__F9y2D","form_title_wrapper":"form_form_title_wrapper__imZGy"};